import { render, staticRenderFns } from "./LockDaysDialog.vue?vue&type=template&id=66a1674a&scoped=true"
import script from "./LockDaysDialog.vue?vue&type=script&lang=js"
export * from "./LockDaysDialog.vue?vue&type=script&lang=js"
import style0 from "./LockDaysDialog.vue?vue&type=style&index=0&id=66a1674a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a1674a",
  null
  
)

export default component.exports